<template>
	<div v-if="hasInitedCustomer" class="full-page">
		<div class="top-bar py-2 px-4" @click="backToLandingRoot">
			<img v-if="provider.logo" class="logo" :src="context.storageEndpoint + provider.logo.file_name"/>
			<img v-else class="logo" src="/img/logo-icon.png"/>
		</div>
		<div class="customer-tab">
			<div class="customer-tab-item tab-info" :class="{'tab-item-active': currentTab === 'member_information'}" @click="currentTab = 'member_information'">
				<span class="d-none d-sm-inline-block">{{$t('tab_member_information')}}</span>
			</div>
			<div class="customer-tab-item tab-bookings" :class="{'tab-item-active': currentTab === 'bookings'}" @click="currentTab = 'bookings'">
				<span class="d-none d-sm-inline-block">{{$t('tab_bookings')}}</span>
			</div>
			<div v-if="customer?.sms_verified" class="customer-tab-item tab-coupons" :class="{'tab-item-active': currentTab === 'coupons'}" @click="currentTab = 'coupons'">
				<span class="d-none d-sm-inline-block">{{$t('tab_coupons')}}</span>
			</div>
			<div class="customer-tab-item tab-booking-passes" :class="{'tab-item-active': currentTab === 'booking_passes'}" @click="currentTab = 'booking_passes'">
                <iconify-icon icon="solar:passport-linear" class="sidebar-icon" width="24" height="24"></iconify-icon>
				<span class="d-none d-sm-inline-block">{{$t('tab_booking_passes')}}</span>
			</div>
		</div>
		<div class="tab-content">
			<customer-information v-if="currentTab === 'member_information'" :context="context" :provider="provider" />
			<customer-bookings v-else-if="currentTab === 'bookings'" :context="context" :provider="provider" />
			<customer-coupons v-else-if="currentTab === 'coupons'" :provider="provider" :context="context" class="mt-4 mx-2"/>
			<customer-booking-passes v-else-if="currentTab === 'booking_passes'" :provider="provider" :context="context" class="mt-4 mx-2"/>
		</div>
	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import api from '../mixins/api.js';
import promptConfirm from '../mixins/prompt-confirm.js';
import fullOverlay from './common/FullOverlay.vue';
import Modal from './common/Modal.vue';
import CustomerBookings from './CustomerBookings.vue';
import RootStore from '../stores/root';
import CustomerCoupons from './crm/CustomerCoupons.vue';
import CustomerInformation from './CustomerInformation.vue';
import CustomerBookingPasses from './crm/CustomerBookingPasses.vue';

export default {
	components: { fullOverlay, Modal, CustomerBookings, CustomerCoupons, CustomerInformation, CustomerBookingPasses },
	store: RootStore,
	mixins: [promptConfirm, api],
	props: {
		context: {type: Object, required: true},
		provider: {type: Object, required: true}
	},
	data() {
		let currentTab = 'member_information';
		if (window.location.search.indexOf('bookings') >= 1) {
			currentTab = 'bookings';
		} else if (window.location.search.indexOf('coupons') >= 1) {
			currentTab = 'coupons';
		} else if (window.location.search.indexOf('booking_passes') >= 1) {
			currentTab = 'booking_passes';
		}
		return {
			currentTab
		};
	},
	watch: {
		currentTab() {
			if (this.currentTab === 'member_information') {
				window.history.replaceState({}, '', '/me');
			} else if (this.currentTab === 'bookings') {
				window.history.replaceState({}, '', '/me?bookings');
			} else if (this.currentTab === 'coupons') {
				window.history.replaceState({}, '', '/me?coupons');
			} else if (this.currentTab === 'booking_passes') {
				window.history.replaceState({}, '', '/me?booking_passes');
			}
		}
	},
	computed: {
		...mapGetters({
			hasInitedCustomer: 'app/hasInitedCustomer',
			customer: 'app/customer'
		}),
	},
	methods: {
		...mapActions({
			initCustomer: 'app/initCustomer',
			logOutCustomer: 'app/logOutCustomer',
			getCurrencies: 'currencies/getCurrencies',
		}),
		backToLandingRoot() {
			window.location = '/';
		},
	},
	async mounted() {
		await this.initCustomer();
		this.getCurrencies();
	}
}
</script>

<style lang="scss" scoped>

.top-bar {
	box-shadow: 0px 3px 6px 2px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	background: white;

	.logo {
		display: block;
		height: 60px;
		cursor: pointer;
	}
}
.full-page {
	color: #707070;
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	overflow: auto;
	z-index: 3000;
	background: white;
	padding-top: 78px;
}

::-webkit-scrollbar {
	display: none;
}

.customer-tab {
	width: 100%;
	display: flex;
	flex-direction: row;

	.customer-tab-item {
		flex-grow: 1;
		text-align: center;
		padding: 16px 32px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;

		@media screen and (max-width: 576px) {
			padding: 12px 8px;
			font-size: 0.875rem;
		}

		&.tab-info::before {
			background: url(/img/icon_customer_info.png);
			content: ' ';
			display: inline-block;
			width: 24px;
			height: 24px;
			background-size: contain;
			margin-right: 8px;
		}

		&.tab-booking-passes {
			padding-bottom: 16px;
		}
		&.tab-bookings::before {
			background: url(/img/icon_customer_bookings.png);
			content: ' ';
			display: inline-block;
			width: 24px;
			height: 24px;
			background-size: contain;
			margin-right: 8px;
		}

		&.tab-coupons::before {
			background: url(/img/customer_coupon.png);
			content: ' ';
			display: inline-block;
			width: 24px;
			height: 24px;
			background-size: contain;
			margin-right: 8px;
		}

		.sidebar-icon {
			margin-bottom: 4px;
			margin-right: 8px;
			color: #707070;
		}

		&.tab-item-active {
			font-weight: bold;
			color: #F1BB6A;
			box-shadow: 0 -4px 0 #F1BB6A inset;

			.sidebar-icon {
				color: #F1BB6A;
			}

			&.tab-info::before {
				background-image: url(/img/icon_customer_info_active.png);
			}
			&.tab-bookings::before {
				background-image: url(/img/icon_customer_bookings_active.png);
			}

			&.tab-coupons::before {
				background-image: url(/img/customer_coupon_active.png);
			}
		}

		&:hover {
			background: #eee;
		}

	}
}

</style>

<i18n>
{
	"en": {
		"greeting": "Hi  {name}",
		"my-bookings": "My Bookings",
		"tab_member_information": "Member Information",
		"tab_bookings": "Bookings",
		"tab_coupons": "Coupons",
		"tab_booking_passes": "Booking Passes"
	},
	"zh": {
		"greeting": "您好 {name}",
		"my-bookings": "目前預約",
		"tab_member_information": "會員資訊",
		"tab_bookings": "預約紀錄",
		"tab_coupons": "優惠券",
		"tab_booking_passes": "課卡"
	}
}
</i18n>